const loginPanels = document.getElementsByClassName("login-panel");
const loginTabButton = document.getElementsByClassName("customer__btn-bar-btn");

if (loginPanels.length === loginTabButton.length) {
  for (let i = 0; i < loginTabButton.length; i++) {
    loginTabButton[i].addEventListener("click", () => handleTabButtonClick(i));
  }

  /**
   * Toggles form that is open
   * @param {number} btnIndex - index of button clicked
   */
  function handleTabButtonClick(btnIndex) {
    const buttonClicked = loginTabButton[btnIndex];
    const panelToOpen = loginPanels[btnIndex];

    if (!buttonClicked.classList.contains("active")) {
      for (let i = 0; i < loginTabButton.length; i++) {
        const button = loginTabButton[i];
        const panel = loginPanels[i];
        button.classList.remove("active");
        button.setAttribute("aria-selected", false);
        panel.classList.add("hidden");
      }

      buttonClicked.classList.add("active");
      buttonClicked.setAttribute("aria-selected", true);
      panelToOpen.classList.remove("hidden");
    }
  }
}

const guestLoginForm = document.getElementById("guest-login-form");

if (typeof guestLoginForm !== "undefined" && guestLoginForm !== null) {
  guestLoginForm.addEventListener("submit", (e) => handleGuestFormSubmit(e));

  function handleGuestFormSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);
    const guestEmail = btoa(data.get("guest-email"));
    Cookies.set("guest", guestEmail);

    const urlParams = new URLSearchParams(window.location.search);
    const redirectParam = urlParams.get("redirect_to");

    if (redirectParam !== null) {
      const decodedParam = atob(redirectParam);
      window.location.href = decodedParam;
    } else {
      //window.history.back();
      window.location.replace("/cart");
    }
  }
}
